import React from 'react';
import {bindActionCreators} from 'redux';
import {useHistory, useParams} from 'react-router-dom';
import {connect} from 'react-redux';
import {loadOrderInfo} from '../../../redux/actions/orderActions';
import {orderPaidTotal, orderToPay, orderTotal} from '../../../redux/selectors/order';
import OrderItem from './components/OrderItem';
import FormattedPrice from '../../../components/FormattedPrice';
import './invoice-page.scss';
import {setPaymentAmount} from '../../../redux/actions/webPayActions';
import {withTranslation} from 'react-i18next';

function InvoicePage({
                       loadOrderInfo, orderInfo, orderItems, branchInfo, payments,
                       payedAmount, toPayAmount, setPaymentAmount, t, currentLanguageId
                     }) {
  const history = useHistory();
  const {branchId, orderId} = useParams();

  const onPayAllClick = async () => {
    await setPaymentAmount(toPayAmount);
    // history.push(`/${branchInfo.branch_guid_code}/invoice/${orderId}/credit-card`);
    history.push(`/${branchInfo.branch_guid_code}/invoice/${orderId}/tips`);
  };

  if (!branchInfo.branch_guid_code) {
    return (
      <div className="invoice-page error">
        <div className="error-payment">
          {t('web_pay.messages.no_order_data_error')}
        </div>
      </div>
    );
  }

  //if (orderInfo.close_time_dt) {
  if (payedAmount !== 0 && payedAmount === orderInfo.order_amount && (orderInfo.order_amount !== 0 || orderInfo.order_amount < 0)) {
    return (
      <div className="invoice-page success">
        <div className="success-payment">
          {t('web_pay.messages.order_paid')}
        </div>
      </div>
    );
  }

  return (
    <div className="invoice-page">
      <div className="invoice-content">        
        <div className="invoice-header">
          {t('web_pay.invoice.invoice_table', {table_number: orderInfo.table_number})}
        </div>
        <div className="invoice-header order">
          {t('web_pay.invoice.order_number', {order_number: orderInfo.order_id})}
        </div>
        <div className="invoice-header waiter">
          {t('web_pay.invoice.waiter')} {orderInfo.employee_name}
        </div>
        <div className="invoice-total total">
          <div className="invoice-info">
            <div className="caption">{t('web_pay.invoice.total_order')}</div>
            <div className="value"><FormattedPrice price={ orderInfo.order_amount } /></div>
          </div>
          <div className="invoice-info discount">
            <div className="caption">{t('web_pay.invoice.order_discount')}</div>
            <div className="value"><FormattedPrice price={ orderInfo.order_discount } /></div>
          </div>
        </div>
        {/* <div className="invoice-discount">
          
        </div> */}
        {payments.length > 0 && (
          <div className="invoice-total">
            <div className="invoice-info payed">
              <div className="caption">{t('web_pay.invoice.payed')}</div>
              <div className="value"><FormattedPrice price={ payedAmount } /></div>
            </div>
            {payments.length > 0 && payedAmount !== orderInfo.order_amount && (          
              <div className="invoice-info to-pay">
                <div className="caption">{t('web_pay.invoice.to_pay')}</div>
                <div className="value"><FormattedPrice price={ toPayAmount } /></div>
              </div>
            )}
          </div>
        )}        

        {payedAmount !== orderInfo.order_amount && (
          <div className="order-items-list">
            {
              orderItems.length > 0 && orderItems.map(item => (
                <OrderItem item={ item } t={ t } currentLanguageId={ currentLanguageId } branchInfo={branchInfo} />
              ))
            }
          </div>
        )}

      </div>

      {payedAmount !== orderInfo.order_amount && (
        <div className="invoice-buttons">
          <div
            className="btn btn-pay-all"
            onClick={ onPayAllClick }
          >
            {t('web_pay.invoice.pay_all_btn')}
          </div>          
        </div>
      )}

    </div>
  );
}

const mapStateToProps = (state) => {
  const {
    branchInfo,
    orderInfo,
    orderItems,
    payments,
    currentLanguageId
  } = state;

  return {
    branchInfo,
    orderInfo,
    orderItems,
    payments,
    payedAmount: orderPaidTotal(state),
    toPayAmount: orderToPay(state),
    currentLanguageId
  };
};

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    loadOrderInfo,
    setPaymentAmount
  },
  dispatch,
);

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(InvoicePage));
